export * from './beneficiary-document-input.component';
